import { BusinessTypes, CompanyGSTTypes } from "../../Types";
import { IIdName } from "../../Types/CommonTypes";
import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { Dayjs } from "dayjs";
import { Voucher_Nature, Voucher_Type } from "./VoucherServices";
import { Setting_Type } from "./UsersService";
import { BankAccountTypes, BusinessNatures } from "./ClientService";
import { TypeOfAddress } from "./LedgerService";

export enum SettingsSections {
  All,
  General,
  Invoice,
  ExportInvoice,
  DeemedExportInvoice,
  SEZInvoice,
  CrNote,
  Receipt,
  Quotation,
  SOrder,
  PurInvoice,
  ExportBill,
  DeemedExportBill,
  SEZBill,
  RCMBill,
  ExpenseJV,
  POrder,
  Payment,
  DrNote,
  Journal,
  Contra,
  DChallan,
  RChallan,
  StockVoucher,
  Asset,
  Dividend,
  Item,
  DueOn,
  TBSettings,
  Template,

  DefaultTemplate,
  JnlTemplate,
  LedgerTemplate,
  DefaultLedger,
  Expenses,
  Income,
  PInvoice,
}

export enum SettingsSectionsName {
  All = "All",
  General = "General",
  Invoice = "Sales",

  ExportInvoice = "Export",

  DeemedExportInvoice = "DeemedExportInvoice",
  SEZInvoice = "SEZInvoice",

  CrNote = "Sales",
  Receipt = "Sales",
  Quotation = "Sales",
  SOrder = "Sales",

  PurInvoice = "Purchase",

  ExportBill = "",
  DeemedExportBill = "",
  SEZBill = "",
  RCMBill = "",
  ExpenseJV = "",

  POrder = "Purchase",
  Payment = "Purchase",
  DrNote = "Purchase",

  Journal = "Journal",
  Contra = "Contra",

  DChallan = "",
  RChallan = "",
  StockVoucher = "",

  Asset = "Assets",

  Dividend = "",
  Item = "",
  DueOn = "",
  TBSettings = "",
  Template = "",

  DefaultTemplate = "",
  JnlTemplate = "",
  LedgerTemplate = "",
  DefaultLedger = "",

  Expenses = "Expenses",
  Income = "Income",

  PInvoice = "Sales",
}

export enum Ordinals {
  Last,
  First,
  Second,
  Third,
  Fourth,
  Fifth,
  Sixth,
  Seventh,
  Eighth,
  Ninth,
  Tenth,
  Eleventh,
  Twelfth,
  Thirteenth,
  Fourteenth,
  Fifteenth,
  Sixteenth,
  Seventeenth,
  Eighteenth,
  Nineteenth,
  Twentieth,
  TwentyFirst,
  TwentySecond,
  TwentyThird,
  TwentyFourth,
  TwentyFifth,
  TwentySixth,
  TwentySeventh,
  TwentyEighth,
  TwentyNinth,
  Thirtieth,
  ThirtyFirst,
}

export enum DayUnits {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Day,
}

export enum Discount_Policy {
  NoDiscount,
  OnlyTradeDiscount,
  OnlyCashDiscount,
  TradenCashDiscount,
}

export enum ItemRate_Type {
  Exclusive,
  Inclusive,
}

export enum DuplicateCopy_Type {
  Original,
  Duplicate,
  Triplicate,
  Quadruplicate,
  Quintuplicate,
}

export enum TimeUnits {
  Day,
  Week,
  Month,
  Year,
}

export enum OrdinalTargets {
  Current,
  Next,
}

export enum DueOnTypes {
  After,
  Ordinal,
  Receipt,
}

export enum VatSubmitType {
  Monthly,
  Quarterly,
  Yearly,
}

export enum InvoiceTemplates {
  Template1,
  Template2,
  Template3,
  Template4,
  Template5,
  Template6,
}

export enum FontPtSizes {
  Eight,
  Nine,
  Ten,
  Eleven,
}
export enum TnC_Position {
  TopRight,
  BottomLeft,
  NextPage,
}
export enum Logo_Position {
  LeftToCompanyName,
  AboveCompanyName,
}
export enum TaxSubtotals {
  TaxRates,
  TaxRatesOverZero,
  SingleTaxSubtotal,
}

export interface IGstShort extends IIdName<number> {
  rate: number;
}
export interface EntitySettings {
  start: string;
  preSuf?: string;
  titleToBePrint?: string;
  yearInclude?: boolean;
  monthInclude?: boolean;
  separator?: string;
  defaultLedger?: string;
  monthNumFormat?: number;
  startNumberFrequency?: number;
  isSuffix?: boolean;
  autoRoundOff?: boolean;
  roundOffType?: RoundOff_Type;
  disclaimer?: string;
}
export interface IInvoiceSettings extends EntitySettings {
  showContactDetail?: boolean;
  showExportDetail?: boolean;
  showReceipt?: boolean;
  showItemDescription?: boolean;
  showDispatchDetail?: boolean;
  showShippingAddress?: boolean;
  showPriceHistory?: boolean;
  showOtherCharges?: boolean;
  eInvoicing?: boolean;
  eWayBilling?: boolean;
  tnCTemplateId?: string;
  termsnConditions?: string;
  discountPolicy?: Discount_Policy;
  itemRateType?: ItemRate_Type;
  invoiceCopyLabelling?: any;
  showFreightType?: boolean;
  showRCM?: boolean;
  defaultNature?: Voucher_Nature;
  returnNoteDayLimit?: number;
}
export interface IExpensesSettings extends EntitySettings {
  showReceipt?: boolean;
  showPriceHistory?: boolean;
  eInvoicing?: boolean;
  discountPolicy?: Discount_Policy;
  showItemDescription?: boolean;
  showRCM?: boolean;
}

export interface ItemSettings {
  preSuf: string;
  start: string;
  isSuffix: boolean;
  notes: string;
  title?: string;
  separator: string;
  maintainCategory: boolean;
  maintainItemGroup: boolean;
  inventoryManage?: boolean;
  maintainItemLocation: boolean;
  isBarcode: boolean;
  isMrp: boolean;
  wholesalePrice: boolean;
  batchTracking: boolean;
  serialTracking: boolean;
}

export interface IDueOn {
  duration: number;
  durationUnit: TimeUnits;
  // ordinal: Ordinals;
  // ordinalUnit: DayUnits;
  // ordinalTarget: OrdinalTargets;
  // type: DueOnTypes;
  creditLimit?: number;
}

export interface IPaymentTerms {
  bank: IIdName;
  showBank: boolean;
  notes: string;
  showNotes: boolean;
}
export interface ITDSDetails {
  isTDSEnabled: boolean;
  tdsDeductorType: number;
}

export interface ITCSDetails {
  isTCSEnabled: boolean;
  tcsCollecteeType: number;
}

export interface IGstDetails {
  isGSTEnabled: boolean;
  gstDetails: IGstDetails;
  scheme: CompanyGSTTypes;
  registrationDate: string | undefined;
  registrationNo: string | undefined;
  submitType: VatSubmitType | undefined;
  gst: IGstShort[] | undefined;
  gstRegDateString: string | undefined;
}
export interface ITrialBalanceSettings {
  hideDecimals: boolean;
  roundToMillion: boolean;
  roundToThousand: boolean;
  showZeros: boolean;
  showNegative: boolean;
  showAccounts: IIdName<number>;
  showCustomCols: boolean;
  showAccBasis: boolean;
  showDatePrepared: boolean;
  showTimePrepared: boolean;
  enableNoteReferencing: boolean;
  notes: string;
  detailed: boolean;
  monthly: boolean;
}
export interface ITemplateSettings {
  type: InvoiceTemplates;
  generalTS: IGeneralTemplateSetting;
  companyTS: ICompanyDetailsTemplateSetting;
  voucherTitleTS: IFontDetailsTemplateSetting;
  buyerShipperTS: IFontDetailsTemplateSetting;
  voucherDetailTS: IVoucherDetailsTemplateSetting;
  itemDetailTS: IItemDetailsTemplateSetting;
  taxSummaryTS: ITaxableValueDetailsTemplateSetting;
  bankDetailTS: IBankDetailsTemplateSetting;
  dispatchDetailTS: IDispatchDetailsTemplateSetting;
  signDetailTS: ISignatureDetailsTemplateSetting;
  // otherTS: IOtherTemplateSetting;
  balanceDetailTS: IBalanceDetailsTemplateSetting;
  termsndConditionTS: ITermsndConditionTSTemplateSetting;
  showHeaderContinuation: boolean;
  name?: string;
}

export interface IHeaderDetailTSTemplateSetting {
  showHeader: boolean;
}

export interface IFontDetailsTemplateSetting {
  fontFamily: string;
  fontSize: number;
}

export interface IBalanceDetailsTemplateSetting {
  font: IFontDetailsTemplateSetting;
  showBalanceStatus: boolean;
}

export interface ITermsndConditionTSTemplateSetting {
  font: IFontDetailsTemplateSetting;
  tnCPosition: TnC_Position;
}

export interface IGeneralTemplateSetting {
  paperSize: string;
  measureIn: string;
  topMargin: string;
  bottomMargin: string;
  leftMargin: string;
  rightMargin: string;
  // addressPadding: number;
  font: IFontDetailsTemplateSetting;
  // headingFontSize: number;
  // taxSubtotals: number;
}

export interface ICompanyDetailsTemplateSetting {
  showLogo: boolean;
  logoAlign: Logo_Position;
  showCompanyAddress: boolean;
  defaultAddress: string | null;
  showGSTIN: boolean;
  showPan: boolean;
  showEmail: boolean;
  showPhone: boolean;
  showWebsite: boolean;
  companyNameFont: IFontDetailsTemplateSetting;
  // headingFontSize: number;
  font: IFontDetailsTemplateSetting;
}

export interface IBuyerShipperDetailsTemplateSetting {
  showShipping: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface IVoucherDetailsTemplateSetting {
  showEWayBillNo: boolean;
  showEInvoiceNo: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface IItemDetailsTemplateSetting {
  // showItemCode: boolean;
  showUnit: boolean;
  showHSN: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface ITaxableValueDetailsTemplateSetting {
  showTaxableValue: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface IBankDetailsTemplateSetting {
  showBankDetail: boolean;
  showQRorUPI: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface IDispatchDetailsTemplateSetting {
  showDispatchDetail: boolean;
  font: IFontDetailsTemplateSetting;
}

export interface ISignatureDetailsTemplateSetting {
  headingFont: IFontDetailsTemplateSetting;
  font: IFontDetailsTemplateSetting;
}

export interface IOtherTemplateSetting {
  showTaxNo: boolean;
  showTaxColumn: boolean;
  taxInclusive: boolean;

  psCreditCard?: {
    name: string;
    id: 0;
  };
  psPayPal?: {
    name: string;
    id: 0;
  };
  psBankPayments?: {
    name: string;
    id: 0;
  };
  contactDetails: boolean;
  showUnitPriceAndQty: boolean;
  showPaymentAdviceCutAway: boolean;
  showRegisteredAddress: boolean;
  hideDisc: boolean;
  showContactAcNo: boolean;
  // showColumnHeading: boolean;
}

export interface addressObject {
  city: string;
  state: number;
  pincode: string;
  country: string;
  building: string;
  street: string;
  landmark: string;
  district: string;
}

export interface ICompanyInfo {
  companyContactDetails: {
    name: string;
    mobile: number;
    email: any;
  };
  name: string;
  panNo: string;
  gstNumber: string;
  appStartDate: string;
  fydate: string;
  financialYearBegin: string;
  regAddress: addressObject;
  startDateString: string;
  businessType: BusinessTypes;
  businessNature: BusinessNatures[];
  businessStart: any;
  bankDetail: IBankDetails;
  address: IAddressDetails;
  tdsDeductible: any;
  tcsApplicability: any;
  logo: any;
}

interface ICompanyContact {
  phone: string;
  email: string;
  mobile: string;
  contactInformation: IContactInformation;
}

export interface IContactInformation {
  name: string;
  designation: string;
  phone: number | null;
  email: string;
  ccTo: string;
  isDefault: boolean;
}

export interface IBankDetails {
  accountHolderName: string;
  ledgerName: string;
  accountNumber: string;
  accountType: BankAccountTypes;
  bankName: string;
  ifsCode: string;
  branch: string;
  upiId: string;
  odLimit: number;
}

export interface IAddressDetails {
  type: TypeOfAddress;
  addressName: string;
  address: addressObject;
}

export interface IPeriod {
  from: Dayjs;
  to: Dayjs;
}

export interface DefaultLedger {
  defaultLedgerId: string;
  voucherType: Voucher_Type;
  voucherTitle: {
    id: number;
    name: string;
  };
}

export interface Vsettings {
  basicSettings: EntitySettings;
  billSettings: IInvoiceSettings;
  invoiceSettings: IInvoiceSettings;
  orderSettings: IInvoiceSettings;
  returnNoteSettings: IInvoiceSettings;
  expenseSettings: IExpensesSettings;
}

export interface vouchersSettings {
  settingType: SettingsSections;
  settings: Vsettings | any;
  title: string;
  id: number;
  system?: boolean;
}

export interface ICompanySettings {
  // DefaultLedgers
  defaultLedgers: DefaultLedger[];

  // All Setting Customization
  vouchersSettings: vouchersSettings[];
  // Sales Invoice
  // invoice: EntitySettings;
  //Sales Estimate
  // estimate: EntitySettings;
  //Sales Receipt
  // receipt: EntitySettings;
  ///CreditNote
  // crNote: EntitySettings;
  ///Contra
  // contra: EntitySettings;
  //Purchase Invoice
  // pInvoice: EntitySettings;
  //Purchase Order
  // pOrder: EntitySettings;
  //Purchase Payment
  // payment: EntitySettings;
  //Purchase CreditNote
  // drNote: EntitySettings;

  //Item
  item: ItemSettings;
  //Expenses
  // expenses: EntitySettings;
  //Income
  // income: EntitySettings;
  //Journal
  // journal: EntitySettings;

  //Delivery challan
  // dChallan: EntitySettings;
  //Sales Order
  // sOrder: EntitySettings;
  //Asset
  // asset: EntitySettings;
  //Dividend
  // dividend: EntitySettings;

  // DueOn
  dueOn: IDueOn;
  //paymentTerms
  paymentTerms: IPaymentTerms;
  //Gst Details
  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // gstDetails: IGstDetails;

  //TBSettings
  tbSettings: ITrialBalanceSettings;
  //company information
  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // companyLogo: any;
  //template settings
  templateSettings: ITemplateSettings[];
  //template settings
  defaultTemplate: InvoiceTemplates;

  // company information
  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // companyInfo: ICompanyInfo;

  // company contact details
  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // companyContactDetails: ICompanyContact;

  //template settings
  defaultTemplateSettings: ITemplateSettings;
  //pdfContent
  pdfContent?: any;
  // tdsDetails?: ITDSDetails;
  // tcsDetails?: ITCSDetails;
}

export interface ICompanyInformation {
  setting: ICompanySettings;
  gsts: any[];
  transactions: number;
  section: SettingsSections;
  templateUrls: Record<InvoiceTemplates, string>;
  period: IPeriod;
}

export enum RoundOff_Type {
  Normal,
  Ceiling,
  Floor,
}

export function getVoucherNameBySettingsSections(
  selSettingSection: SettingsSections
): string {
  switch (selSettingSection) {
    case SettingsSections.Asset:
      return "Asset";
    case SettingsSections.Contra:
      return "Contra";
    case SettingsSections.CrNote:
      return "Credit Note";
    case SettingsSections.DrNote:
      return "Debit Note";
    case SettingsSections.Expenses:
      return "Expense";
    case SettingsSections.Income:
      return "Income";
    case SettingsSections.Invoice:
      return "Sales";
    case SettingsSections.PurInvoice:
      return "Purchase";
    case SettingsSections.SOrder:
      return "Sales Order";
    case SettingsSections.POrder:
      return "Purchase Order";
    case SettingsSections.Quotation:
      return "Estimate";
    case SettingsSections.Journal:
      return "Journal";
    case SettingsSections.PInvoice:
      return "Proforma Invoice";
    case SettingsSections.Payment:
      return "Payment";
    case SettingsSections.Receipt:
      return "Receipt";
    case SettingsSections.StockVoucher:
      return "Stock";
    default:
      return "All";
  }
}
export function getVoucherTypeBySettingsSections(
  selSettingSection: SettingsSections
): Voucher_Type {
  switch (selSettingSection) {
    case SettingsSections.Asset:
      return Voucher_Type.Asset;
    case SettingsSections.Contra:
      return Voucher_Type.Contra;
    case SettingsSections.CrNote:
      return Voucher_Type.CreditNote;
    case SettingsSections.DrNote:
      return Voucher_Type.DebitNote;
    case SettingsSections.Expenses:
      return Voucher_Type.Expenses;
    case SettingsSections.Income:
      return Voucher_Type.Income;
    case SettingsSections.Invoice:
      return Voucher_Type.SalesVoucher;
    case SettingsSections.PurInvoice:
      return Voucher_Type.PurchaseVoucher;
    case SettingsSections.SOrder:
      return Voucher_Type.SalesOrder;
    case SettingsSections.POrder:
      return Voucher_Type.PurchaseOrder;
    case SettingsSections.Quotation:
      return Voucher_Type.Quotation;
    case SettingsSections.Journal:
      return Voucher_Type.Journal;
    case SettingsSections.PInvoice:
      return Voucher_Type.PInvoice;
    case SettingsSections.Payment:
      return Voucher_Type.Payment;
    case SettingsSections.Receipt:
      return Voucher_Type.Receipt;
    case SettingsSections.StockVoucher:
      return Voucher_Type.StockVoucher;
    default:
      return Voucher_Type.All;
  }
}

export function getSettingsSectionByVoucherType(
  voucherType: Voucher_Type
): SettingsSections {
  switch (voucherType) {
    case Voucher_Type.Asset:
      return SettingsSections.Asset;
    case Voucher_Type.Contra:
      return SettingsSections.Contra;
    case Voucher_Type.CreditNote:
      return SettingsSections.CrNote;
    case Voucher_Type.DebitNote:
      return SettingsSections.DrNote;
    case Voucher_Type.Expenses:
      return SettingsSections.Expenses;
    case Voucher_Type.Income:
      return SettingsSections.Income;
    case Voucher_Type.SalesVoucher:
      return SettingsSections.Invoice;
    case Voucher_Type.PurchaseVoucher:
      return SettingsSections.PurInvoice;
    case Voucher_Type.SalesOrder:
      return SettingsSections.SOrder;
    case Voucher_Type.PurchaseOrder:
      return SettingsSections.POrder;
    case Voucher_Type.Quotation:
      return SettingsSections.Quotation;
    case Voucher_Type.Journal:
      return SettingsSections.Journal;
    case Voucher_Type.PInvoice:
      return SettingsSections.PInvoice;
    case Voucher_Type.Payment:
      return SettingsSections.Payment;
    case Voucher_Type.Receipt:
      return SettingsSections.Receipt;
    case Voucher_Type.StockVoucher:
      return SettingsSections.StockVoucher;
    default:
      return SettingsSections.All;
  }
}
class SettingService {
  //private route = "/V1/API/Acc_New_CompanySettings/";
  private routes = "/V1/API/Billing/Acc_New_CompanySettings"; // this is for new companysSettrings
  //https://localhost:7142/v1/api/CompanySettings/648985973b462a99cead6bbe'post'

  PostSetting = (clientID: string, params: any) =>
    ApiUtility.post(`${this.routes}${clientID}`, params);

  //https://localhost:7142/v1/api/CompanySettings/6463611020350584c0d5c017

  // getSetting = (clientId: string) => {};

  //https://localhost:7142/v1/api/CompanySettings/6463611020350584c0d5c017/64f8184e546060b017eb53ae

  getSetting = (clientID: string, id?: string) =>
    ApiUtility.get(`${this.routes}/${clientID}/${id}`);

  getVoucherNameListSetting = (clientID: string) =>
    ApiUtility.get(`${this.routes}/${clientID}/AllVoucherTemplateNameList`);

  getCompanySettings = (clientID: string, sections: SettingsSections) =>
    ApiUtility.get(`${this.routes}/${clientID}?section=${sections}`);

  updateCompanySettings = (
    clientId: string,
    sections: SettingsSections,
    params?: ICompanySettings,
    // voucherTitle?: string,
    voucherId?: number | 0
  ) =>
    ApiUtility.post(
      `${this.routes}/${clientId}?section=${sections}&VoucherId=${voucherId}`,
      // `${this.routes}${clientId}?section=${sections}&VoucherTitle=${voucherTitle}&VoucherId=${voucherId}`,
      params
    );
  // https://localhost:7142/v1/api/CompanysSettings/650c285fcd07a89b4aa10fa3?section=17

  addSettingCustomization = (clientId: string, params: ICompanySettings) =>
    ApiUtility.post(`${this.routes}/${clientId}/CreateVoucherTemplate`, params);

  deleteSettingCustomization = (clientId: string, VSetId: number) =>
    ApiUtility.delete(
      `${this.routes}/${clientId}/DeleteVoucherTemplate?VSetId=${VSetId}`
    );
}
export default new SettingService();
